import {
  useRuntimeConfig,
  useRoute,
  useCurrentLanguage,
  useState,
  computed
} from "#imports";
function getTo(route, language) {
  const singleLanguage = route.meta.language;
  const languageMapping = route.meta.languageMapping;
  if (singleLanguage) {
    if (language !== singleLanguage) {
      return;
    }
  }
  if (languageMapping && languageMapping[language]) {
    return {
      path: languageMapping[language]
    };
  }
  const name = (route.name || "").toString().split("___")[0];
  return {
    name: name + "___" + language,
    language,
    params: {
      ...route.params
    }
  };
}
export function useLanguageLinks() {
  const config = useRuntimeConfig().public.languageNegotiation;
  const availableLanguages = config.availableLanguages;
  const currentLanguage = useCurrentLanguage();
  const route = useRoute();
  const pageLanguageLinksPath = useState(
    "pageLanguageLinksPath",
    () => ""
  );
  const pageLanguageLinksLinks = useState(
    "pageLanguageLinksLinks",
    () => null
  );
  const links = computed(() => {
    if (pageLanguageLinksPath.value && pageLanguageLinksPath.value === route.path && pageLanguageLinksLinks.value) {
      return Object.keys(pageLanguageLinksLinks.value).map((code) => {
        return {
          code,
          active: code === currentLanguage.value,
          to: pageLanguageLinksLinks.value[code]
        };
      });
    }
    const match = route.matched[0];
    if (!match) {
      return [];
    }
    const matchLanguageMapping = match.meta.languageMapping;
    if (match.meta.languageMapping && typeof matchLanguageMapping === "object" && matchLanguageMapping !== null) {
      return Object.entries(match.meta.languageMapping).map(([code, to]) => {
        return {
          code,
          active: code === currentLanguage.value,
          to
        };
      });
    }
    return availableLanguages.map((code) => {
      return {
        code,
        active: code === currentLanguage.value,
        to: getTo(route, code)
      };
    });
  });
  return links;
}
